<template lang="pug">
    div
        TemplateMenu(
            :message-templates="templates"
            :apply-message-template="applyTemplate"
            :type="type"
            v-if="renderTemplateMenu"
        )

        TagMenu(
            :menu-tags="menuTags"
            :apply-message-template="applyTemplate"
            :type="type"
            v-if="renderTagMenu"
        )
</template>

<script lang="ts">
import Vue from 'vue';

// Components
import TemplateMenu from '@/components/communication_center/shared/template_menu.vue';
import TagMenu from '@/components/communication_center/shared/tag_menu.vue';

export default Vue.extend({
    data() {
        return {
            menuTags: [],
        }
    },
    methods: {
        buildTagMenu() {
            // If either are empty, abort
            if (!(this.templates?.length > 0 && this.tags?.length > 0)) {
                return;
            }

            const notTaggedObj = {
                account_id: 0,
                tag_id: 0,
                templates: [],
                name: "Other",
            }
            const tagIDs = [];
            const tagMap = {};
            this.menuTags = [];
            for (let i = 0; i < this.templates.length; i++) {

                // Init template
                const template = this.templates[i];

                // Init bool to represent whether or not the template was matched
                let matchedTag = false;

                // Loop through all resource tags to match templates
                for (let j = 0; j < this.tags.length; j++) {

                    // Init resource tag
                    const tag = this.tags[j];

                    // Check if they match - if not, continue on
                    if (this.type === 'message') {
                        if (tag?.message_template_id !== template?.message_template_id) {
                            continue
                        }
                    } else if (this.type === 'email') {
                        if (tag?.resourceable_id !== template?.email_template_id) {
                            continue
                        }
                    }

                    if (!!tagMap[tag.tag_id]) {
                        tagMap[tag.tag_id].templates.push(template);                            
                    } else {

                        // Init tag
                        const tagObj = {
                            account_id: tag.account_id,
                            templates: [template],
                            name: tag.tag_name,
                            tag_id: tag.tag_id,
                        }

                        // Set on map
                        tagMap[tag.tag_id] = tagObj;

                        // Push into ID array so we know which tags to grab later
                        tagIDs.push(tag.tag_id);
                    }

                    // Mark matched as true
                    matchedTag = true;
                }

                // If not tagged, push into other bucket
                if (!matchedTag) {
                    notTaggedObj.templates.push(template);
                }
            }

            // Build menu tags from map
            if (tagIDs?.length > 0) {
                for (let i = 0; i < tagIDs.length; i++) {
                    const id = tagIDs[i];
                    if (id > 0) {
                        const tag = tagMap[id];
                        if (tag) {
                            this.menuTags.push(tag);
                        }
                    }
                }
            }

            // If we have not tagged templates, append onto menu
            if (notTaggedObj?.templates?.length > 0) {
                this.menuTags.push(notTaggedObj);
            }

            // Sort tags
            this.sortMenuTags();

            return;
        },
        sortMenuTags() {
            if (this.menuTags?.length > 0) {
                this.menuTags = this.menuTags.sort(function(x, y) {
                    return (x?.name || "").localeCompare(y?.name || "");
                });
            }
        },
    },
    computed: {
        renderTemplateMenu() {
            return (this.templates?.length > 0 && this.menuTags?.length === 0);
        },
        renderTagMenu() {
            return (this.menuTags?.length > 0);
        },
    },
    components: {
        TemplateMenu,
        TagMenu,
    },
    props: {
        applyTemplate: Function,
        templates: Array,
        tags: Array,
        type: String,
    },
    watch: {
        tags: {
            handler() {
                this.buildTagMenu();
            },
            deep: true,
        },
        templates: {
            handler() {
                this.buildTagMenu();
            },
            deep: true,
        },
    },
    mounted() {
        this.buildTagMenu();
    },
})
</script>

<style lang="scss" scoped>

</style>